<template>
  <div id="post">
    <transition name="fade">
      <RingLoader v-if="showPost == false" :color="this.spinnerColor" :size="this.spinnerSize"></RingLoader>
    </transition>
    <Post v-if="showPost == true" :fullPost="this.post"></Post>
  </div>
</template>

<script>
import Post from './Post.vue'
import firebase from 'firebase'
import 'firebase/firestore'
const db = firebase.firestore()
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: { Post, RingLoader },
  data () {
    return {
      post: '',
      showPost: false,
      spinnerColor: '#2674a3',
      spinnerSize: '50px'
    }
  },
  created () {
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      let self = this;
      var docRef = db.collection("posts").doc(this.$route.params.id);
      docRef.get().then(function(doc) {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          self.post = doc.data()
          self.post.id = doc.id
          setTimeout(function () {
            self.showPost = true
          }, 2000)
        } else {
              // doc.data() will be undefined in this case
          console.log("No such post!");
        }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PostPage.vue